import { useState } from "react";
import { Accordion, Card, Col, Row, useAccordionButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AiFillCaretDown, AiFillCaretRight, AiOutlineFile } from "react-icons/ai";
import { toast } from "react-toastify";
import { ButtonFavorite } from "../../../../../components/button-favorite";
import { FlatCardObject } from "../../../../../components/flat-card-object";
import { IMaterial } from "../../../../../models/IMaterial";
import { IObjectResponse } from "../../../../../models/IObjectResponse";
import { removeFavorite } from "../../../../../services/favorites.service";
import { Objects } from "../../../home/styles";
import { CardDescription } from "../discipline-accordion/styles";
import { CardButton, CardUnity } from "./styles";

function CustomToggle({ children, eventKey, activeEventKey }: any) {
    const decoratedOnClick = useAccordionButton(eventKey, () => {
        activeEventKey(eventKey);
    });

    return (
        <div onClick={decoratedOnClick}>
            {children}
        </div>
    );
}

export function UnityAccordion(props: any) {
    const { t: translation } = useTranslation();
    const [activeKey, setActiveKey] = useState<string>('')

    const handleActiveCurrentKey = (key: any) => {
        if (activeKey === key) {
            setActiveKey('');
        } else {
            setActiveKey(key);
        }
    }

    const handleRemoveFavorite = (id: number) => {
        removeFavorite(id).then(() => {
            toast.success('Material removido com sucesso!', {
                position: "bottom-center",
            })
        }).catch((err: any) => {
            toast.error('Ocorreu um erro ao remover este material.')
        })
    }

    return (
        <Accordion>
            {!!props.unities && props.unities.map(((unity: IMaterial, index: string) => {
                return (
                    <Card className="mb-3" key={index} id={index}>
                        <CustomToggle eventKey={index} activeEventKey={handleActiveCurrentKey}>
                            <CardUnity>
                                <Row>
                                    <Col>{activeKey === index ? (<AiFillCaretDown></AiFillCaretDown>) : (<AiFillCaretRight></AiFillCaretRight>)} {unity.title}</Col>
                                    <Col>
                                        <CardButton onClick={(event) => event.preventDefault()}>
                                            <ButtonFavorite key={index} material={unity} isMaterialView={false} variant="blueberry" materialType="Item" removeFavorite={handleRemoveFavorite} />
                                        </CardButton>
                                    </Col>
                                </Row>
                            </CardUnity>
                        </CustomToggle>
                        <Accordion.Collapse eventKey={index}>
                            <Card.Body>
                                {
                                    unity?.description &&
                                    <Row className="mb-3">
                                        <Col>
                                            <CardDescription>
                                                <div className="title mb-2"><AiOutlineFile fontSize={20} style={{ marginTop: '-5px' }}></AiOutlineFile> {translation('material.menu')}</div>
                                                <div dangerouslySetInnerHTML={{ __html: unity?.description || translation('userAccount.uninformed') }}></div>
                                            </CardDescription>
                                        </Col>
                                    </Row>
                                }
                                <Objects>
                                    {!!unity?.medias && unity?.medias.map((arrayMedias: IObjectResponse) => {
                                        return (

                                            <div key={index}>
                                                <FlatCardObject detailsMode object={arrayMedias} />
                                            </div>
                                        )
                                    })}
                                    {unity.medias?.length === 0 ? (
                                        <h6>Nenhum arquivo na unidade.</h6>
                                    ) : (
                                        <></>
                                    )}
                                </Objects>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                )
            }))}
        </Accordion>
    )
}